import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bda9c28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "font-bold" }
const _hoisted_2 = { class: "py-2 flex flex-col gap-y-2" }
const _hoisted_3 = { class: "border rounded-2xl py-1 flex flex-col justify-center items-center bg-gray-200 lg:gap-x-2 lg:flex-row lg:px-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bookmark !font-semibold" }, null, -1))
const _hoisted_5 = { class: "text-xs lg:font-medium" }
const _hoisted_6 = { class: "border rounded-2xl py-1 flex flex-col justify-center items-center bg-gray-200 lg:gap-x-2 lg:flex-row lg:px-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-users !font-semibold" }, null, -1))
const _hoisted_8 = { class: "text-xs lg:font-medium" }

import { PropType } from "vue";
import Calendar from "primevue/calendar";
import { CalendarReservations } from "@/types";
import { DateToISOString } from "@/assets/utils/DateToISOString";
type Reservation = CalendarReservations & { date: string };

export default /*#__PURE__*/_defineComponent({
  __name: 'Calendar',
  props: {
  reservations: {
    type: Object as PropType<Reservation>,
    default: () => ({}),
  },
  url: {
    type: String,
    default: "",
  },
},
  emits: ["dateClick", "monthChange"],
  setup(__props, { emit }) {

const props = __props;



const getRecapOfDate = (options: {
  year: number;
  month: number;
  day: number;
  [key: string]: any;
}) => {
  const { year, month, day } = options;
  const date = DateToISOString.create(new Date(year, month, day)).value;
  return { ...props.reservations[date], date };
  //return DateToISOString.create(date).value;
};
const monthChange = async ({
  month,
  year,
}: {
  month: number;
  year: number;
}) => {
  emit("monthChange", { month, year });
};

const dateClick = (date: CalendarReservations) => {
  emit("dateClick", date);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Calendar), {
    inline: "",
    class: "calendar w-full",
    onMonthChange: monthChange
  }, {
    date: _withCtx(({ date }) => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(__props.url ? 'a' : 'div'), {
        href: `${__props.url}?startDate=${getRecapOfDate(date).date}&endDate=${
          getRecapOfDate(date).date
        }`,
        onClick: ($event: any) => (dateClick(getRecapOfDate(date).date)),
        class: "day-item w-full border rounded-xl m-1 h-36 px-1 flex flex-col justify-between items-center lg:h-32 hover:cursor-pointer hover:bg-gray-200"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(date.day), 1),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, _toDisplayString(getRecapOfDate(date)?.reservationsCount), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(getRecapOfDate(date)?.attendeesCount), 1)
            ])
          ])
        ]),
        _: 2
      }, 1032, ["href", "onClick"]))
    ]),
    _: 1
  }))
}
}

})